import React, { useState, useEffect, lazy, Suspense } from "react";

const WaitlistDesktop = lazy(() => import("../components/WaitlistDesktop"));
const WaitlistMobile = lazy(() => import("../components/WaitlistMobile"));

const Waitlist = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {isMobile ? <WaitlistMobile /> : <WaitlistDesktop />}
    </Suspense>
  );
};

export default Waitlist;
